import styled from "styled-components";

export const DigitalShareTableRow = styled.tr``;

export const DigitalShareTableHeader = styled.th`
    padding: 10px 15px;
`;

interface IDigitalShareTableDataProps {
    isDifferent?: boolean;
}

export const DigitalShareTableData = styled.td<IDigitalShareTableDataProps>`
    font-family: "Manrope-Bold";
    padding: 10px 15px;
    ${props => props.isDifferent ? `
        color: #434a54;
        font-size: 14px;
        text-align: left !important;
    ` : `
        color: black;
        font-size: 18px;
    `}
`;

export const DigitalShareTable = styled.table`
    width: 100%;
    border-radius: 3px;
    ${DigitalShareTableHeader}, ${DigitalShareTableData} {
        border: 1px solid #e8e8e8;
        border-collapse: collapse;
        text-align: center;
    }
`;
